import React from 'react';
import MultiselectFilter from './MultiselectFilter';
const CustomizeColumn = ({ options, itemId = item => item.id, itemTitle = item => item.name, liveSearch = true, ...rest }) => (<MultiselectFilter {...rest} liveSearch={liveSearch} icon="columns" iconType="fa" itemId={itemId} itemTitle={itemTitle} options={options}/>);
export default CustomizeColumn;
